export default "__VITE_ASSET__6jPPajFZ__"